import { ApplicationTopicGroup } from "../../../api/publicApi/createCase/applicationTopicOptions";
import { FormStore } from "./formStore";

export const getSelectedSubApplications = (
    formStore: FormStore,
    applicationTopicGroup: ApplicationTopicGroup
): ApplicationTopicGroup[] => {
    const selectedApplications = formStore.state.selectedApplications || [];
    const subApplications: ApplicationTopicGroup[] = [];
    applicationTopicGroup.children
        .filter((application) => selectedApplications.includes(application.id))
        .map((application) => application.children?.forEach((group) => subApplications.push(group)));
    return subApplications;
};
